module.exports = __webpack_public_path__ + "static/Q1Answer6_Sleeping_Dog_RegineTholen-9a4d90f853c536d99c67fabe6d3c6ae4.jpg";